(ns rothko.theme.manatee.accordion)

(def main
  {:primary
   {}})
